import React from "react";
import "../../css/home/footer.css";
import { firmIcons, IconAdress } from './constants.js';
import { useNavigate, } from "react-router-dom";

function Icons({ alt, src, onClick }) {
    return (
        <img
            onClick={() => onClick && window.open(onClick, "_blank")}
            className="icons"
            src={src}
            alt={alt}
            style={{ cursor: "pointer" }} // Kullanıcıya tıklanabilir olduğu hissini verir
        />
    );
}


function IconCard() {
    const twitter = `${IconAdress}twitter.png`;
    const facebook = `${IconAdress}facebook.png`;
    const instagram = `${IconAdress}instagram.png`;
    const linkedin = `${IconAdress}linkedin.png`;
    const youtube = `${IconAdress}youtube.png`;
    return (
        <div className="FooterContainer">
            <Icons src={twitter} alt="twitter" onClick="https://x.com/doganatesdap" />
            <Icons src={facebook} alt="facebook"
                onClick="https://www.facebook.com/p/DO%C4%9EANATE%C5%9E-ELEKTR%C4%B0K-100049628445026/" />
            <Icons src={instagram} alt="instagram" onClick="https://www.instagram.com/doganateselektrik/" />
            <Icons src={linkedin} alt="linkedin"
                onClick="https://www.linkedin.com/company/doganateselektrik/?originalSubdomain=tr" />
            <Icons src={youtube} alt="youtube" onClick="https://www.youtube.com/@doganateselektrik/videos" />
        </div>)
}

function AdresRows({ icon, text, href }) {
    return (
        <div className="footerRow">
            {href ? (
                <a href={href} className="icon-link" target="_blank" rel="noopener noreferrer">
                    <img className="icons" src={icon} alt="icon" />
                </a>
            ) : (
                <img className="icons" src={icon} alt="icon" />
            )}
            <h5 className="footerText1">{text}</h5>
        </div>
    );
}

function Adresses({ city }) {
    const phone = `${IconAdress}phone.png`;
    const email = `${IconAdress}web.png`;
    const address = `${IconAdress}location.png`;
    const fax = `${IconAdress}phone.png`;
    const email2 = `${IconAdress}mail.png`;

    return (
        <div>        
                <AdresRows icon={phone} text=" +90 422 237 51 97" href="tel:+904222375197" />
                <AdresRows icon={fax} text=" +90 422 237 52 87" href="fax:+904222375287" />
                <AdresRows
                        icon={address}
                        href="https://www.google.com/maps/place/Do%C4%9Fanate%C5%9F+Elektrik/@38.3384117,38.1982799,17z/data=!3m1!4b1!4m6!3m5!1s0x407631d796c8e379:0x872ddaf7e97baa7a!8m2!3d38.3384117!4d38.1982799!16s%2Fg%2F11h1tj10dd?entry=ttu&g_ep=EgoyMDI0MTEyNC4xIKXMDSoASAFQAw%3D%3D"
                        text={
                            <>
                                1. Organize San. Böl. 1. Cad. No : 3
                                <br />
                                Yeşilyurt-MALATYA/TÜRKİYE
                            </>
                        }
                    />
                    <AdresRows icon={email2} text="info@doganates.com" href="mailto:info@doganates.com" />
                    <AdresRows icon={email} text="www.doganates.com" href="https://www.doganates.com" />               
        </div>
    );
}


function FooterColums({ Header, items, onClick }) {
    const handleClick = () => {
        if (onClick) {
            onClick();
            window.scrollTo(0, 0);
        }
    };
    return (
        <div className="footerColumn">
            <h4 className="footerText">{Header}</h4>
            {items.map((item, index) => (
                <h5 key={index} className="footerText2" onClick={handleClick}>{item}</h5>
            ))}
        </div>
    );
}

function Footer() {
    const navigate = useNavigate();
    const handleLogoClick = () => {
        window.open("https://www.doganates.com", "_blank");
    };
    const handleSolutionsClick = () => {
        navigate("/solitions");
        window.scrollTo(0, 0);
    };
    // const handlePowerManagementClick = () => {
    //     navigate("/powermanagement");
    //     window.scrollTo(0, 0);
    // };
    // const handleProductsClick = () => {
    //     navigate("/products");
    //     window.scrollTo(0, 0);
    // };
    const handleContactClick = () => {
        navigate("/contact");
        window.scrollTo(0, 0);
    };

    const logoB = `${firmIcons}blogo.png`;
    const dapCharge = `${firmIcons}DapSarj-Colorcolor-01.png`;
    return (

        <div>
            <div className="FooterRow">
                <div>
                   <div className="dap-sarj-container">
                    <img src={dapCharge} className="DapChargeIcon" alt="dap logo" onClick={handleLogoClick} />
                    </div>
                    <div className="adress-container">
                    <Adresses city="Malatya" />
                    </div>
                </div>
                <FooterColums
                    onClick={handleContactClick}
                    Header="Şirket"
                    items={["İş Birliklerimiz", "Teknik Servislerimiz", "Satış Servislerimiz", "İş Ortaklarımız", "İletişim"]}
                />
                <FooterColums
                    onClick={handleContactClick}
                    Header="Keşfet"
                    items={["Doğanates Elektrik", "Dap Pano", "Dap Aydınlatma", "Dap Kanal", "Dap Kabin",]} />
                <div>
                    <FooterColums
                        onClick={handleSolutionsClick}
                        Header="Üretim"
                        items={["AC Şarj İstasyonları", "DC Şarj İstasyonları", "Ekipler", "Yazılımlar", "Diğer Modüller"]} />
                </div>
                <div>
                    <div className="doganates-container">
                        <img onClick={handleLogoClick} width="120" src={logoB} className="DoganAtesIcon" alt="a" />
                        <IconCard />
                    </div>
                </div>
            </div>

        </div>

    )
}

export default Footer;